import React from 'react';
import { DesignSizeTypeSetCategory, TemplateSetDesignsQuery } from 'graphql/generated/types.autogenerated';
import DisplayLayout from './DisplayLayout';
import SocialLayout from './SocialLayout';
import SocialPostLayout from './SocialPostLayout';
import VideoLayout from './VideoLayout';

type TemplatesLayoutProps = {
  design: TemplateSetDesignsQuery['templateSetDesigns'];
  layout?: DesignSizeTypeSetCategory;
};

export default function TemplatesLayout({ design, layout }: TemplatesLayoutProps) {
  if (!design.sizes || design.sizes.length === 0) {
    return null;
  }

  switch (layout) {
    case DesignSizeTypeSetCategory.VIDEO:
      return <VideoLayout sizes={design.sizes} />;
    case DesignSizeTypeSetCategory.SOCIAL_POST:
      return <SocialPostLayout sizes={design.sizes} />;
    case DesignSizeTypeSetCategory.SOCIAL_CAMPAIGN:
      return <SocialLayout sizes={design.sizes} />;
    default:
      return <DisplayLayout sizes={design.sizes} />;
  }
}
